module.exports = __webpack_public_path__ + "9299b8cdf0c237e67254955364f12a76.png";